export default class CategoryFilter {
    constructor(...ops) {
        this.smartGrid = ops[0];
        this.init();
    }

    init() {
        var self = this;
        this.filterableList = this.smartGrid.querySelector(".smartGrid__list--filterable");

        if (this.filterableList) {
            this.listItems = this.filterableList.children;
            this.categoryOptions = this.smartGrid.querySelectorAll(".categoryOption");
            this.viewAllOption = [...this.categoryOptions].filter(opt => opt.dataset.value == "view-all")[0];
            this.allowMultiple = this.filterableList.classList.contains("smartGrid__filterableList--allowMultiple");

            var optionsArea = this.smartGrid.querySelector(".smartGrid--filterOptions");
            var fullOptionsList = [...this.categoryOptions].map(d => d.dataset.value);

            this.setFilterFns();
            this.updateFilters();

            // add event listeners to category options
            if (this.categoryOptions.length > 0) {
                this.categoryOptions.forEach(element => {
                    element.addEventListener("click", () => self.changeCategory(element));
                });
            }

            var categoryListItems = this.smartGrid.querySelectorAll(".smartGridItem__category");
            if (categoryListItems.length > 0) {
                categoryListItems.forEach(li => {
                    li.addEventListener("click", function() {
                        var catValue = this.dataset.value;
                        var optionTab = optionsArea.querySelector("div[data-value=" + catValue + "]");

                        if (!optionTab) {
                            optionTab = document.createElement("div");
                            optionTab.classList = "tabs__tab tabs__option categoryOption active category--selected";
                            optionTab.dataset.value = catValue;
                            optionTab.innerHTML = this.innerHTML;
                            optionTab.addEventListener("click", () => self.changeCategory(optionTab));
                            optionsArea.append(optionTab);
                            fullOptionsList.push(catValue);
                            self.categoryOptions = self.smartGrid.querySelectorAll(".categoryOption");
                        }

                        self.resetSelected(optionTab); // pass element as exception
                        self.updateFilters();

                        window.scrollTo({
                            top: self.smartGrid.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop) - 50,
                            left: 0,
                            behavior: "smooth"
                        });
                    });
                });
            }
        }
    }

    changeCategory(element) {
        var value = element.dataset.value;
        var reset = value == "view-all";
        var forceReset = this.currentFilters.length == 1 && value == this.currentFilters[0];

        if (forceReset) {
            this.viewAllOption.classList.add("active");
            this.viewAllOption.classList.add("category--selected");
            element.classList.remove("active");
            element.classList.remove("category--selected");
        } else if (!this.allowMultiple || reset) {
            this.resetSelected(element); // pass element as exception
        } else {
            this.viewAllOption.classList.remove("active");
            this.viewAllOption.classList.remove("category--selected");
            element.classList.toggle("active");
            element.classList.toggle("category--selected");
        }

        this.updateFilters(reset);
    }

    showItem(el) {
        el.classList.remove("hide");
    }

    hideItem(el) {
        el.classList.add("hide");
    }

    setFilterFns() {
        var self = this;
        var exclusive = this.filterableList.hasAttribute("data-exclusive-filter");

        this.showHideEl = exclusive
            ? function(categoriesList, currentFilters, el) {
                  for (let i = 0; i < currentFilters.length; i++) {
                      let filter = currentFilters[i];
                      if (!categoriesList.includes(filter)) {
                          self.hideItem(el);
                          return;
                      }
                  }
                  self.showItem(el);
              }
            : function(categoriesList, currentFilters, el) {
                  for (let i = 0; i < currentFilters.length; i++) {
                      let filter = currentFilters[i];
                      if (categoriesList.includes(filter)) {
                          self.showItem(el);
                          return;
                      }
                  }
                  self.hideItem(el);
              };
    }

    resetSelected(exception = null) {
        for (let i = 0; i < this.categoryOptions.length; i++) {
            let option = this.categoryOptions[i];
            if (exception && option == exception) {
                option.classList.add("active");
                option.classList.add("category--selected");
            } else {
                option.classList.remove("active");
                option.classList.remove("category--selected");
            }
        }
    }

    updateFilters(reset = false) {
        this.currentFilters = reset
            ? []
            : [
                  ...new Set(
                      Array.from(this.smartGrid.getElementsByClassName("category--selected"))
                          .map(d => d.dataset.value)
                          .filter(d => d && !["view-all"].includes(d))
                  )
              ];

        this.updateVisible();
    }

    updateVisible() {
        let visible = 0;

        for (let i = 0; i < this.listItems.length; i++) {
            let el = this.listItems[i];
            let categories = el.getAttribute("data-categories");

            if (this.currentFilters.length == 0) {
                this.showItem(el);
            } else if (categories) {
                let categoriesList = categories.split(",");
                this.showHideEl(categoriesList, this.currentFilters, el);
            } else {
                this.hideItem(el);
            }

            if (!el.classList.contains("hide")) {
                visible++;
            }
        }

        /* assess for special cases */
        if (visible === 0) {
            this.filterableList.classList.add("smartGrid__filterableList--noResults");
        } else {
            this.filterableList.classList.remove("smartGrid__filterableList--noResults");
            if (visible === 2) {
                this.filterableList.classList.add("smartGrid__filterableList--twoResults");
            } else {
                this.filterableList.classList.remove("smartGrid__filterableList--twoResults");
            }
        }
    }
}
